import { BASE_URL } from '@/config';
import axios from 'axios';
import qs from 'qs';

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve();
        }
    });
    failedQueue = [];
};

const apiInstance = axios.create({
    withCredentials: true,
});

apiInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (
            (error.response?.status === 401 || error.response?.status === 403) &&
            !originalRequest._retry &&
            originalRequest.withCredentials !== false
        ) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then(() => apiInstance(originalRequest))
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                await axios.post(
                    `${import.meta.env.VITE_REACT_APP_CORE_ENGINE_URL}/user/refreshToken`,
                    {},
                    { withCredentials: true },
                );

                processQueue(null);
                return apiInstance(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError);
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/';
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    },
);

// Main API request function
export function APIClient(endpoint: string, payload?, apiParams?: { requestType?: string, contentType?: string, responseType?: string, baseUrl?: string, [key: string]: string | boolean }) {

    const { contentType, requestType, responseType, baseUrl, ...rest } = apiParams || {};
    if (contentType === 'application/x-www-form-urlencoded') {
        payload = qs.stringify(payload);
    }
    const baseurl = baseUrl || BASE_URL;
    const config = {
        method: requestType || 'get',
        url: `${baseurl}${endpoint}`,
        headers: {
            'Content-Type': contentType || 'application/json',
        },
        withCredentials: true,
        ...(requestType?.toLowerCase() !== 'get' && { data: payload }),
        ...(responseType && { responseType }),
        ...(rest || {})
    };

    // **Ensure binary data (PDF) is handled correctly**
    if (contentType === 'application/pdf') {
        config.responseType = 'arraybuffer';
    }

    return apiInstance(config as any);
}

// Error handler
export function HandleError(err) {
    if (err.response) {
        return `Error: ${err.response.data.message || err.response.data.detail || err.response.data?.errorMessage
            }`;
    }
    if (err.request) {
        return `Error: ${err.request}`;
    }
    return `Error: ${err.message}`;
}
